<div class="vocal-container">
  <div *ngIf="!isPlaying && !isRecording && !end" class="form-group vocal-form">
    <label class="place-holder-label">{{
      "SERVICE_AROUND.SEND_VOCAL" | translate
    }}</label>
  </div>

  <div *ngIf="!isPlaying && isRecording && !end" class="form-group vocal-form">
    <button class="btn-pause" (click)="toggleRecording()"></button>
    <div class="progress-container">
      <div
        class="progress-bar"
        [style.width.%]="progressBarValue * 166.66"
      ></div>
    </div>
    <span class="time">{{ formatTime(progressBarValue.toFixed(2)) }}</span>
    <button class="btn-delete" (click)="deleteRecording()"></button>
  </div>

  <div *ngIf="!isRecording && end" class="form-group vocal-form">
    <!-- *ngIf="!isPlaying && !inPause" -->
    <button
      class="btn-pause"
      [class]="{ 'in-pause': !isPlaying && !inPause }"
      (click)="toggleRecording()"
    ></button>
    <!-- <button
      class="btn-pause"
      *ngIf="isPlaying || inPause"
      [class]="{ 'in-pause': isPlaying && inPause }"
      (click)="toggleRecording()"
    ></button> -->
    <div class="progress-container">
      <div
        class="progress-bar"
        [style.width.%]="(progressBarValue / duration) * 100"
      ></div>
    </div>
    <span class="time">{{ formatTime(progressBarValue.toFixed(2)) }}</span>
    <button class="btn-delete" (click)="deleteRecording()"></button>
  </div>
  <!--  recording buttons group -->
  <div class="recording-buttons-group" >
    <!-- drop recording button -->
    <button
      type="button"
      class="button drop-recording-button"
      (click)="deleteRecording()"
    ></button>
    <!-- send recording button -->
    <button
      type="button"
      class="button send-button"
      (click)="sendVoiceMessage()"
    ></button>
  </div>
</div>
